export const PWA_APP_INSTALLED = 'PWA_APP_INSTALLED';
